export default __webpack_public_path__ + "static/media/a016-market-4.642745bf.jpg";